import { styled, typography } from '@pulse-web-ui/theme';

export const SubTitle = styled.div`
  ${typography.regular18};
  line-height: 26px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 32px;
`;
